<script setup lang="ts">
  import type { IdfTag } from '@/types/idf-tag'
  import { UiButton } from '@logistiek-zonder-papier/lzp-library'

  defineProps<{
    tags: IdfTag[]
    label: string
    removeTag: (id: string) => void
  }>()
</script>

<template>
  <div>
    <div class="label">Geselecteerde {{ label }}</div>
    <div class="tags">
      <div v-for="tag in tags" :key="tag.id" class="tag">
        <div class="tag-name">
          {{ tag.name }}
        </div>
        <UiButton @click="removeTag(tag.id)" variant="negative" icon="cross" size="small" />
      </div>
    </div>
  </div>
</template>

<style scoped>
  .label {
    margin-bottom: var(--spacing-xs);
    color: var(--colours-grey-5);
    font-size: 0.9rem;
    font-style: normal;
    font-weight: 500;
    line-height: 2rem;
  }

  .tag-name {
    margin-right: var(--spacing-s);
  }

  .tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: var(--spacing-s);
  }

  .tag {
    display: flex;
    align-items: center;
    background: var(--colours-grey-3);
    padding-right: var(--spacing-s);
    padding: 0.3rem 0.6rem;
    border-radius: 0.5rem;
    font-size: 0.9rem;
  }
</style>
